import React from 'react';
import { Typography } from '@mui/material';
import DS_Button from 'mui/components/elements/DS_ButtonLink';
import { formatDate, formatTime } from 'components/Booking-new/utils/helpers/bookingMomentHelpers';

import useConfirmationDialog from './hooks/useConfirmationDialog';
import {
  StyledDialog,
  StyledPaper,
  StyledDialogContent,
  StyledDialogContentText,
  StyledDialogActions,
} from './ConfirmationDialogStyles';

/**
 * Customized Dialog component from MUI.
 * Accepts labels for confirm and cancel actions.
 * https://mui.com/material-ui/api/dialog/
 *
 * @param {React.ReactNode} ButtonComponent
 * @param {Object} buttonProps
 * @param {() => void} onConfirm
 * @param {String} date
 * @param {String} time
 * @param {Object} location
 * @param {String} cancelButtonLabel
 * @param {String} confirmButtonLabel
 * @returns {React.ReactFragment}
 */
function ConfirmationDialog({
  ButtonComponent,
  buttonProps,
  onConfirm,
  date,
  time,
  location,
  cancelButtonLabel,
  confirmButtonLabel,
  handleGTMAppointmentTimeSelectedEvent,
  timestamp,
  showTimeSlots,
}) {
  const { isOpen, handleOpen, handleClose } = useConfirmationDialog({
    handleGTMAppointmentTimeSelectedEvent,
    timestamp,
    location,
    showTimeSlots,
  });

  return (
    <>
      <ButtonComponent {...buttonProps} active={buttonProps.active || isOpen} onClick={handleOpen}>
        {buttonProps.text}
      </ButtonComponent>
      <StyledDialog
        open={isOpen}
        onClose={handleClose}
        PaperComponent={StyledPaper}
        PaperProps={{ elevation: 0 }}
        aria-describedby="booking-confirmation-dialog-description"
      >
        <StyledDialogContent>
          <StyledDialogContentText id="booking-confirmation-dialog-description" component="div">
            <Typography variant="DS_copyMediumBold" component="p">
              {formatDate(date)}, {formatTime(time)}
            </Typography>
            <Typography variant="DS_copyMediumRegular" component="p">
              {location?.heading}
            </Typography>
          </StyledDialogContentText>
        </StyledDialogContent>
        <StyledDialogActions>
          <DS_Button
            onClick={handleClose}
            buttonVariant="outlined"
            buttonSize={false}
            title={cancelButtonLabel || 'cancel'}
          />
          <DS_Button onClick={onConfirm} buttonSize={false} title={confirmButtonLabel || 'book'} />
        </StyledDialogActions>
      </StyledDialog>
    </>
  );
}

export default ConfirmationDialog;
